import { render } from "./HomeComponent.vue?vue&type=template&id=0412c328&scoped=true&ts=true"
import script from "./HomeComponent.vue?vue&type=script&lang=ts"
export * from "./HomeComponent.vue?vue&type=script&lang=ts"

import "./HomeComponent.vue?vue&type=style&index=0&id=0412c328&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0412c328"]])

export default __exports__